import { createApp } from 'vue';
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import App from './App.vue';
import './main.css';
import Default from '@/shared/layouts/Default.vue';
import router from '@/shared/router';
import { initStore } from '@/shared/store';
import '@/shared/utils/clearDatabase';

const app = createApp(App);

const queryClient = new QueryClient();

const pinia = initStore();

app.use(VueQueryPlugin, { queryClient });
app.use(router);
app.use(pinia);

app.component('default-layout', Default);

app.mount('#app');
